// src/forms/index.ts
function createZodResolver(schema) {
  return (values) => {
    const result = schema.safeParse(values);
    if (result.success) {
      return { values: result.data, errors: {} };
    }
    const errors = {};
    for (const issue of result.error.issues) {
      const path = issue.path.join(".") || "root";
      if (!errors[path]) errors[path] = { type: issue.code, message: issue.message };
    }
    return { values: {}, errors };
  };
}
function applyServerErrors(error, setError, opts = {}) {
  const body = "error" in error ? error.error : error;
  const details = body.details ?? {};
  let mappedAny = false;
  for (const [field, value] of Object.entries(details)) {
    const message = Array.isArray(value) ? String(value[0]) : String(value);
    setError(field, { type: body.error_code ?? "server", message });
    mappedAny = true;
  }
  if (!mappedAny) {
    setError(opts.rootField ?? "root", { type: body.error_code ?? "server", message: body.message });
  }
}
function firstErrorMessage(result) {
  const errs = result.errors;
  const first = Object.values(errs ?? {})[0];
  return first?.message ?? null;
}

export { applyServerErrors, createZodResolver, firstErrorMessage };
//# sourceMappingURL=chunk-IH33UABN.js.map
//# sourceMappingURL=chunk-IH33UABN.js.map